import { getApigeeUrl, getEnv } from '@adsk/acs-sc-web-platform-api';
import { RFI_PATHS } from './constants';

export const getApiBaseUrl = (projectId: string) => {
  const env = getEnv();
  const apigeeUrl = getApigeeUrl();
  const RFIsPath = RFI_PATHS[env];
  const apiBaseUrl = `${apigeeUrl}${RFIsPath}/projects/${projectId}`;
  return apiBaseUrl;
};
